<template>
  <v-app>
    <v-content>
      <NavBar />
      <router-view :key="$route.fullPath" />
    </v-content>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'App',

  components: {
    NavBar
  },

  data: () => ({
    //
  })
}
</script>
